/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import React from "react";
import styled from "styled-components";
import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalBarSeries,
  AreaSeries,
} from "react-vis";

// Estilos para la tarjeta
const StyledCard = styled.div`
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0px 0px 6px #0000001a;
  border-radius: 8px;
  padding: 2em;

  .title {
    text-transform: uppercase;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 12px; // Ajusta el tamaño del título en dispositivos más pequeños
    }
  }
`;

interface HorizontalBarCustomProps {
  labels: Array<string>;
  data: Array<number>;
}

const HorizontalBarCustom: React.FC<HorizontalBarCustomProps> = ({
  labels,
  data,
}) => {
  // Formateamos los datos para que se ajusten al formato que react-vis espera
  const formattedData = labels
    .map((label, index) => ({
      y: label,
      x: data[index],
      isMax: data[index] === Math.max(...data), // Indica si es la cantidad máxima vendida
    }))
    .slice(0, 3);

  // Calculamos el ancho de las barras en función de la longitud de formattedData
  const barWidth = 0.2 + 0.2 / formattedData.length;

  // Calculamos el valor máximo de ventas para establecer el rango en el eje x
  const maxSales = Math.max(...data);

  return (
    <StyledCard>
      <div className="title">Gráfico de Ventas de Productos</div>
      <XYPlot
        yType="ordinal"
        xType="linear"
        width={500}
        height={300}
        margin={{ left: 350 }}
        xDomain={[0, maxSales + 1]} // Establece el rango máximo en el eje x
      >
        <XAxis
          style={{
            text: { fontSize: "10px" },
          }}
        />
        <YAxis
          style={{
            text: {
              fontSize: "10px",
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxHeight: "30px", // Establece la altura máxima del texto para aproximadamente dos líneas
            },
          }}
        />
        <HorizontalBarSeries
          barWidth={barWidth}
          colorType="literal"
          data={formattedData}
          color="#EC932F"
          onValueClick={(datapoint) => {
            console.log(
              `Producto: ${datapoint.y}, Cantidad Vendida: ${datapoint.x}`
            );
          }}
        />
        <AreaSeries color="#EC932F" />
      </XYPlot>
    </StyledCard>
  );
};

export default HorizontalBarCustom;
